/**
 * AnyClip — 백엔드 API 호출 래퍼
 */

import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * 다운로드 URL 추출 요청
 * @param {string} url - 대상 영상 URL
 * @param {string} initData - Telegram WebApp.initData
 * @param {string} telegramId - 개발 모드 전용
 */
export async function requestDownload(url, initData, telegramId) {
  const response = await axios.post(`${BASE_URL}/api/download`, {
    url,
    initData: initData || undefined,
    telegramId: telegramId || undefined,
  });
  return response.data;
}

/**
 * 유저 상태 조회
 */
export async function fetchUserStatus(initData, telegramId) {
  const response = await axios.get(`${BASE_URL}/api/user/status`, {
    data: { initData, telegramId },
  });
  return response.data;
}

/**
 * CPA 오퍼 보상 요청 (티켓 5장)
 */
export async function submitCpaReward(initData, telegramId) {
  const response = await axios.post(`${BASE_URL}/api/reward/cpa`, {
    initData: initData || undefined,
    telegramId: telegramId || undefined,
  });
  return response.data;
}

/**
 * 비디오 시청 보상 요청 (티켓 1장)
 */
export async function submitVideoReward(initData, telegramId) {
  const response = await axios.post(`${BASE_URL}/api/reward/video`, {
    initData: initData || undefined,
    telegramId: telegramId || undefined,
  });
  return response.data;
}

/**
 * Telegram Stars 인보이스 발송 요청
 * @param {string} initData - Telegram WebApp.initData
 * @param {string} telegramId - 유저 ID
 * @param {number} amount - 구매할 티켓 수 (= Stars 수)
 */
export async function requestStarsInvoice(initData, telegramId, amount) {
  const response = await axios.post(`${BASE_URL}/api/reward/stars/invoice`, {
    initData: initData || undefined,
    telegramId: telegramId || undefined,
    amount,
  });
  return response.data;
}
